import { useMemo } from "react";
import { useSelector } from "src/redux/hooks";
import { getUserId } from "src/utils";
import { mapUsers } from "../utils/mapUsers";

// Narrowed to the current user only, since generic/bridge accounts and named
// accounts source their name+rank from different, independently-loaded lists.
export const useAuthorizationUsers = () => {
  const defaultUsers = useSelector(state => state.generatorSlice.users);
  const bridgeLogUsers = useSelector(
    state => state.generatorSlice.bridgeLogUsers,
  );
  const { isGenericAccount } = useSelector(state => state.permsSlice);

  return useMemo(() => {
    const mappedDefaultUsers = defaultUsers
      ? mapUsers(defaultUsers, "", "role firstname surname")
      : [];
    const preferred = isGenericAccount
      ? (bridgeLogUsers ?? [])
      : mappedDefaultUsers;
    const fallback = isGenericAccount ? mappedDefaultUsers : bridgeLogUsers;
    const list = preferred.length > 0 ? preferred : (fallback ?? []);

    const currentUser = list.find(u => u.value === getUserId());
    return currentUser ? [currentUser] : [];
  }, [defaultUsers, bridgeLogUsers, isGenericAccount]);
};
